import { makeUsersAvailable } from "@/data/UserHub.ts";
import { makeOnlineProviderAvailable } from "@/data/OnlineProviderHub.ts";
import { makeDeliverySettingsAvailable } from "@/data/DeliverySettingsHub.ts";
import DeliveryManagementPlugin from "@delivery-management/DeliveyMangement/DeliveryManagementPlugin.tsx";
import GoogleMapsProvider from "@/react/core/GoogleMapsProvider.tsx";
import { dataLock } from "@/data/DataUtils.ts";
import { useAsyncEffect } from "@/react/core/reactive.ts";
import {
  _setV,
  setIsValidatingOnlineOrders,
  setOnlineOrdersPage
} from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { OnlineOrder } from "@/data/OnlineOrder.ts";
import { memo } from "react";

const DeliveryManagementView = () => {
  makeDeliverySettingsAvailable()
  makeOnlineProviderAvailable()
  makeUsersAvailable()

  useAsyncEffect(async () => {
    await dataLock.acquireAsync()
    setIsValidatingOnlineOrders(true)
    setOnlineOrdersPage(1)
    _setV(prev => prev + 1)
    OnlineOrder.$.subscribe(async _e => {
      setIsValidatingOnlineOrders(true)
      setOnlineOrdersPage(1)
      _setV(prev => prev + 1)
    })
  }, [])

  return (
    <GoogleMapsProvider>
      <DeliveryManagementPlugin />
    </GoogleMapsProvider>
  )
}

export default memo(DeliveryManagementView);